import { IUser } from '@/types/user';
import { create } from 'zustand';
import useTicketStore from './ticket-store-map';
/**
 * Esta store se usa para poder guardar los datos en el LS por usuario
 */
interface UserTicketStore {
    user: IUser | null;
    setUser: (user: IUser | null) => void;
}

export const useTicketUserStore = create<UserTicketStore>((set) => ({
    user: null,
    setUser: (user) => {
        set({ user })
        if(user){
            useTicketStore.persist.rehydrate();
        }
    },
}));
